import React from "react";
import { Container } from "react-bootstrap";
import { Section } from "../../shared";

function ContactUs() {
  const contactUs = [

    {
      id: 1,
      name: 'Biennial Reports and Annual Facility Reports',
      link: 'https://dtsc.ca.gov/annual-biennial-report/',
      email: 'brsstaff@dtsc.ca.gov',
      phoneNumber: '800-618-6942',
      inquiryTopic: 'Reporting requirements, when reports are due, what forms are required',
    },

    {
      id: 2,
      name: 'Electronic Verification Questionnaire (eVQ)',
      link: 'https://evq.dtsc.ca.gov/Home.aspx',
      email: 'evq@dtsc.ca.gov',
      phoneNumber: '877-454-4012',
      inquiryTopic: 'eVQ system: logging in, password resets, other system questions',
    },

    {
      id: 3,
      name: 'E-Manifest',
      link: 'https://www.epa.gov/e-manifest',
      email: 'e-manifest@dtsc.ca.gov',
      phoneNumber: '800-618-6942',
      inquiryTopic: 'How to register for e-Manifest, who is required to use',
    },
    {
      id: 4,
      name: 'Environmental Complaint',
      link: 'https://calepa.ca.gov/enforcement/complaints/',
      email: '',
      phoneNumber: '',
      inquiryTopic: 'Report an environmental problem anywhere in California, whether it affects the quality of the air or water, the handling of hazardous or solid waste, or the use of pesticides.',
    },
    {
      id: 5,
      name: 'General Inquiries',
      link: null,
      email: 'hwtsadmn@dtsc.ca.gov',
      phoneNumber: '800-618-6942',
      inquiryTopic: '',
    },
    {
      id: 6,
      name: 'Hazardous Waste Alert Hotline (DTSC)',
      link: null,
      email: '',
      phoneNumber: '800-698-6942',
      inquiryTopic: '',
    },
    {
      id: 7,
      name: 'Hazardous Waste Tracking System (HWTS)',
      link: 'https://hwts.dtsc.ca.gov/',
      email: 'hwtsadmn@dtsc.ca.gov',
      phoneNumber: '800-618-6942',
      inquiryTopic: 'How to view an ID number profile and manifest data, prebuilt HWTS reports, request a custom HWTS report, request a HWTS user account (for regulatory agency users only)',
    },
    {
      id: 8,
      name: 'Manifest Correction',
      link: 'https://dtsc.ca.gov/hazardous-waste-manifest-information/',
      email: 'manifestcorrections@dtsc.ca.gov',
      phoneNumber: '800-618-6942',
      inquiryTopic: 'How to correct incorrect manifest data',
    },
    {
      id: 9,
      name: 'RCRAInfo',
      link: 'https://rcrainfo.epa.gov/rcrainfoprod/action/secured/login',
      email: 'myrcraid@dtsc.ca.gov',
      phoneNumber: '800-618-6942',
      inquiryTopic: 'How to access the RCRAInfo site, status of RCRA permissions requests and federal ID number submissions, EPA Form 8700-12',
    },
    {
      id: 10,
      name: 'Regulatory Assistance Office',
      link: 'https://dtsc.ca.gov/rao/',
      email: 'rao@dtsc.ca.gov',
      phoneNumber: '800-728-6942',
      inquiryTopic: 'Informal guidance regarding the management of hazardous waste, including compliance assistance, information, and research services',
    },
    {
      id: 11,
      name: 'State Hazardous Waste ID Numbers and Federal EPA ID Numbers',
      link: 'https://dtsc.ca.gov/apply-for-hazardous-waste-epa-id-number/',
      email: 'idnumber@dtsc.ca.gov',
      phoneNumber: '800-618-6942',
      inquiryTopic: 'General questions about ID numbers, DTSC Form 1358 submissions',
    },
    {
      id: 12,
      name: 'Transporters',
      link: 'https://dtsc.ca.gov/transporters/',
      email: 'transporter@dtsc.ca.gov',
      phoneNumber: '800-618-6942',
      inquiryTopic: 'Submit documents related to an application deficiency, general questions about how to apply to be a transporter',
    }
  ];

  return (
    <div className="">
      <Section title="Contact Us" type={"standout"} />
      <div className="container">
        <Container>

          <table className="contact-grid">
            <thead>
              <tr>
                <th>Topic</th>
                <th style={{ width: "125px" }}>Phone Number</th>
                <th>Email Address</th>
                <th >Description</th>
              </tr>
            </thead>
            <tbody>
              {contactUs.map(item => (
                <tr key={item.id}>
                  <td>
                    {item.link == null ?
                      <span>{item.name}</span> :
                      (<a href={item.link} target="_blank" rel="noreferrer">{item.name}</a>)}
                  </td>
                  <td>{item.phoneNumber}</td>
                  <td>
                    <a href={"mailto:" + item.email}>{item.email}</a>
                  </td>
                  <td>{item.inquiryTopic}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </Container>
      </div>
    </div>
  );
}

export default ContactUs;

